import * as React from "react";
import { SVGProps, memo } from "react";

const SvgAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.819 4.516a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM.075 16.485h13.85V10.56c0-1.056-1.015-1.778-1.993-1.525-1.298.336-3.413.59-4.932.59v-.001c-1.548 0-3.635-.252-4.933-.589-.978-.253-1.992.47-1.992 1.524v5.926Zm1.506-5.951a.052.052 0 0 0-.006.025v4.426h10.85V10.56a.053.053 0 0 0-.007-.027.086.086 0 0 0-.025-.028.098.098 0 0 0-.084-.018c-1.291.335-3.497.7-5.31.7v.003c-1.832 0-4.017-.368-5.308-.703a.098.098 0 0 0-.085.018.086.086 0 0 0-.025.028Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgAccount);

export default Memo;
